@if (merchantId && merchant) {
  <div class="edit-container">
    <div class="edit-content">
      @if (!closeEdit) {
        <app-merchant-edit-form
          [merchant]="merchant"
          [merchantId]="merchantId"
          [logoBase64]="logoBase64"
          (statusChanged)="onMerchantChanged()"
          (infoChanged)="onMerchantChanged()"
          (logoUpdated)="onLogoUpdated($event)"
          />
      }
      <app-merchant-user-management
        [merchantId]="merchantId"
        (expandUserManagement)="onExpandRight($event)"
        [page]="'edit'"
        />
    </div>
  </div>
}